module.exports = __webpack_public_path__ + "img/c_1.ecd395b8.jpg";